module.exports = __webpack_public_path__ + "img/escenario2.714ac652.jpg";